import { lazy } from 'react'
import { BackBtn } from '@nv/basic-components'
import { Announce, Skeleton, useNVModal } from '@nv/components'
import { useGetEvent } from '@nv/hooks'
import CalendarCheckIcon from '@nv/images/design/calendar-check-icon'
import EditIcon from '@nv/images/design/edit-icon'
import SendIcon from '@nv/images/design/send-icon'
import { AdminInstantMeetingService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './AdminInstantVotingHeader.module.scss'
const InstantVotingEventClone = lazy(() => import('@nv/lazy-loadable/lib/modals/InstantVotingEventClone'))

export const AdminInstantVotingHeader = ({ eventId }: any) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const navigate = useNavigate()
  const event = useGetEvent(eventId)
  const { NVModal: InstantVotingEventCloneModal, openModal: openInstantVotingEventCloneModal } = useNVModal()

  const onCloneEvent = async (originalEventId, clonedEventData) => {
    try {
      await AdminInstantMeetingService.cloneEvent(originalEventId, clonedEventData)
    } catch (err) {
      console.error('Failed to clone event', err)
    }
  }

  return (
    <>
      <Announce title={t('pages.announcements.instantVotingDetailsPage')} setPageName={true} />

      <InstantVotingEventCloneModal>
        <InstantVotingEventClone eventToClone={event} onClone={(data) => onCloneEvent?.(event._id, data)} />
      </InstantVotingEventCloneModal>

      <div className={styles['container']}>
        <BackBtn navigateTo={`/admin/instant-voting`} />
        <div className={styles['header']}>
          <CalendarCheckIcon />
          <div className={styles['header__details']}>
            <h1>{event ? event.name[currentLanguage] : <Skeleton width={300} height={32} />}</h1>
            <div className={styles['header__classification']}>{t('admin.instantVoting.boardOfDirectors')}</div>
          </div>

          <div className={styles['header__actions']}>
            <SendIcon onClick={openInstantVotingEventCloneModal} />
            <EditIcon onClick={() => navigate(`/admin/edit-instant-voting/${eventId}`)} />
          </div>
        </div>
      </div>
    </>
  )
}

export default AdminInstantVotingHeader
